import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGrowth = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 13,
	height: 13,
	viewBox: "0 0 13 13",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M6.06343 1.46308C6.30027 1.21186 6.69974 1.21186 6.93657 1.46308L10.5463 5.29199C10.9072 5.67476 10.6358 6.30357 10.1097 6.30357H2.89026C2.36419 6.30357 2.09282 5.67476 2.45368 5.29199L6.06343 1.46308Z",
		fill: "#28C07B"
	}), /* @__PURE__ */ _jsx("rect", {
		x: 4.14062,
		y: 4.14258,
		width: 4.71429,
		height: 7.85714,
		rx: .6,
		fill: "#28C07B"
	})]
});
export default SvgGrowth;
